import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface ExemptionType {
  id?: number;
  name: string;
  description?: string | null;
  active: boolean;
  sortOrder: number;
}

@Injectable({ providedIn: 'root' })
export class ExemptionTypesService {
  private baseUrl = `${environment.apiUrl}/api/admin/exemption-types`;

  constructor(private http: HttpClient) {}

  /** Active types for return-line dropdowns (not admin-gated). */
  active(): Observable<ExemptionType[]> {
    return this.http.get<ExemptionType[]>(`${environment.apiUrl}/external/exemption-types`);
  }

  getAll(): Observable<ExemptionType[]> {
    return this.http.get<ExemptionType[]>(this.baseUrl);
  }

  create(data: ExemptionType): Observable<ExemptionType> {
    return this.http.post<ExemptionType>(this.baseUrl, data);
  }

  update(id: number, data: ExemptionType): Observable<ExemptionType> {
    return this.http.put<ExemptionType>(`${this.baseUrl}/${id}`, data);
  }
}
